import AccountDeletionPageLayout from "./PageLayout";
import AccountDeletionCard from "./AccountDeletionCard";

const AccountDeletion = () => {
  return (
    <AccountDeletionPageLayout>
      <AccountDeletionCard />
    </AccountDeletionPageLayout>
  );
};

export default AccountDeletion;
